import type { AmbleContent } from "..";
import { ukDefaultTermsOfPolicy } from "../shared/terms-of-policy";
import { insurerLogosAmbles } from "./insurerLogos";

/**
 * UK-specific ambles for SimpleBusiness UK
 */
export const simplybusinessUkAmbles: Record<string, AmbleContent> = {
  ...insurerLogosAmbles,
  terms_of_policy: ukDefaultTermsOfPolicy,
};
